import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  margin: 1em;
`;

export const TimeContainer = styled.div`
  font-size: 23cqmin;
  font-weight: 100;
`;

export const DateContainer = styled.div`
  font-size: 4cqw;
  font-weight: 100;
`;
